import { DefaultValues, useForm, UseFormReturn } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Employer } from 'services/requests';
import { useSubscribeUpdate } from 'hooks/common';
import { yupEmployerName, yupEmployerType } from 'utils';
import { QueryKeys } from 'constants/queryKeys';

export enum EmployerFieldNames {
  name = 'name',
  type = 'type',
}

export enum employerTypeOptions {
  multipleEmployeesType = 'Multiple-employees',
}

export const defaultValues: DefaultValues<EmployerForm> = {
  name: '',
  type: employerTypeOptions.multipleEmployeesType,
};

type EmployerForm = {
  name: string;
  type: string;
};

export const useEmployerForm = (employer?: Employer): UseFormReturn<EmployerForm> => {
  const queryKey = [QueryKeys.employer, employer?.id];

  const schema = yup.object({
    name: yupEmployerName,
    type: yupEmployerType(Object.values(employerTypeOptions)),
  });

  const form = useForm<EmployerForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: yupResolver(schema),
    defaultValues: !!employer
      ? {
          name: employer.name,
          type: employerTypeOptions.multipleEmployeesType,
        }
      : { name: '', type: '' },
  });

  useSubscribeUpdate(queryKey, (data?: Employer) => {
    if (data) {
      form.reset({
        ...data,
      });
    }
  });

  return form;
};
